/* eslint-disable no-plusplus */
/* eslint-disable no-console */
/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Tabs, Tab, Button, Backdrop, CircularProgress, } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import * as validation from '../../shared/validation';
import columnDefs from '../../column-defs';
import '../../styles/forgot-password.scss';
import {
  TemplateArgo, ROMOpen, multiPass_icon, roEdi_icon, singlePass_icon, tutorial_icon,
  multiPass_hover, roEdi_hover, singlePass_hover, tutorial_hover, TemplateArgo_hover
} from '../../shared/assets/images';
import { getUserListData, readPreconfigFilesFromS3 } from '../../shared/api/url-helper';
import { removeItemFromLocalStorage } from '../../shared/removeElements';
import { removeLocalStorageValue } from '../../shared/helper';
import HeaderSection from '../header-section';
import './preconfig.scss';
import { setPreconfigFiles, getPreconfigFiles, readPreconfigFilesFromS3_temp } from '../userData';

let currentPreConfigActive = 0;

const PreConfigV = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const translateObject = t;

  const [data, setData] = React.useState([]);
  const [icons, setIcons] = React.useState([]);
  const [fileName_SinglePass, setFileName_SinglePass] = React.useState([]);
  const [fileName_MultiPass, setFileName_MultiPass] = React.useState([]);
  const [fileName_IntROEDI, setFileName_IntROEDI] = React.useState([]);
  const [fileName_Argo, setFileName_Argo] = React.useState([]);
  const [fileName_Tutorial, setFileName_Tutorial] = React.useState([]);
  const [loadedFile, setLoadedFile] = useState([]);
  const [fileType, setFileType] = useState('');
  const [authData] = useState({});
  const [, setFlowsheetType] = useState('');
  const [firstFlag, setFirstFlag] = useState(true);
  const [fetchLoading, setFetchLoading] = useState(false);

  // validation layer start
  const { schema } = columnDefs.forgotpassword.forms;
  const { email } = authData;
  validation.validation({
    schema,
    data: {
      email,
    },
  });
  const [value, setValue] = React.useState(0);
  const handleChangetab = (event, newValue) => {
    setValue(newValue);
  };
  const selectedFile = (type, i) => {
    currentPreConfigActive = i;
    setFlowsheetType(type);
    if (i === 0) {
      setLoadedFile([...fileName_SinglePass]);
      setFileType('SinglePass');
    } else if (i === 1) {
      setLoadedFile([...fileName_MultiPass]);
      setFileType('MultiPass');
    } else if (i === 2) {
      setLoadedFile([...fileName_IntROEDI]);
      setFileType('IntROEDI');
    } else if (i === 3) {
      setLoadedFile([...fileName_Argo]);
      setFileType('IntROEDI');
    } else if (i === 4) {
      setLoadedFile([...fileName_Tutorial]);
      setFileType('Tutorial');
    }
  };

  const getOnlyFileName = (arr) => {
    return arr.map(item => item.split('preconfig/')[1].split('.json')[0]);
  };

  useEffect(() => {
    setData([
      { label: 'Single-Pass Design', id: 'single-pass' },
      { label: 'Multi-Pass Design', id: 'multi-pass' },
      { label: 'Integrated RO-EDI', id: 'integrated-ro-edi' },
      { label: 'Argo Analyzer', id: 'argo-analyzer' },
      { label: 'Tutorial', id: 'tutorial-file' }
    ]);
    setIcons([
      {
        defaultImage: singlePass_icon,
        hoverImage: singlePass_hover, // active or selected both
      },
      {
        defaultImage: multiPass_icon,
        hoverImage: multiPass_hover,
      },
      {
        defaultImage: roEdi_icon,
        hoverImage: roEdi_hover,
      },
      {
        defaultImage: TemplateArgo,
        hoverImage: TemplateArgo_hover,
      },
      {
        defaultImage: tutorial_icon,
        hoverImage: tutorial_hover,
      }
    ]);

    let singlePass = [];
    let MultiPass = [];
    let EDIFlowsheet = [];
    let argoAnalyzer = [];
    let tutorial = [];

    if (getPreconfigFiles()) {
      const readPreconfigFilesFrom_S3 = getPreconfigFiles();
      singlePass = getOnlyFileName(readPreconfigFilesFrom_S3['Single Pass']);
      MultiPass = getOnlyFileName(readPreconfigFilesFrom_S3['Multi-Pass']);
      EDIFlowsheet = getOnlyFileName(readPreconfigFilesFrom_S3['EDI Flowsheets']);
      argoAnalyzer = getOnlyFileName(readPreconfigFilesFrom_S3['Argo Analyzer']);
      tutorial = getOnlyFileName(readPreconfigFilesFrom_S3.Tutorial);

      setFileName_SinglePass([...singlePass]);
      setFileName_MultiPass([...MultiPass]);
      setFileName_IntROEDI([...EDIFlowsheet]);
      setFileName_Argo([...argoAnalyzer]);
      setFileName_Tutorial([...tutorial]);

      if (firstFlag) {
        setFirstFlag(false);
        selectedFile('Single-Pass Design', 0);
        setLoadedFile([...singlePass]);
        getUserListData();
      }

    }
    else {
      setFetchLoading(true);
      readPreconfigFilesFromS3()
        .then((response) => {
          setPreconfigFiles(response.data);

          const readPreconfigFilesFrom_S3 = response.data;

          singlePass = getOnlyFileName(readPreconfigFilesFrom_S3['Single Pass']);
          MultiPass = getOnlyFileName(readPreconfigFilesFrom_S3['Multi-Pass']);
          EDIFlowsheet = getOnlyFileName(readPreconfigFilesFrom_S3['EDI Flowsheets']);
          argoAnalyzer = getOnlyFileName(readPreconfigFilesFrom_S3['Argo Analyzer']);
          tutorial = getOnlyFileName(readPreconfigFilesFrom_S3.Tutorial);

          setFileName_SinglePass([...singlePass]);
          setFileName_MultiPass([...MultiPass]);
          setFileName_IntROEDI([...EDIFlowsheet]);
          setFileName_Argo([...argoAnalyzer]);
          setFileName_Tutorial([...tutorial]);

          if (firstFlag) {
            setFirstFlag(false);
            selectedFile('Single-Pass Design', 0);
            setLoadedFile([...singlePass]);
            getUserListData();
          }
          setFetchLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setFetchLoading(false);
        });

    }

    // Abhihsek 14-4 start
    // const readPreconfigFilesFrom_S3 = readPreconfigFilesFromS3_temp;

    // const singlePass = getOnlyFileName(readPreconfigFilesFrom_S3['Single Pass']);
    // const MultiPass = getOnlyFileName(readPreconfigFilesFrom_S3['Multi-Pass']);
    // const EDIFlowsheet = getOnlyFileName(readPreconfigFilesFrom_S3['EDI Flowsheet']);
    // const argoAnalyzer = getOnlyFileName(readPreconfigFilesFrom_S3['Argo Analyzer']);
    // const tutorial = getOnlyFileName(readPreconfigFilesFrom_S3.Tutorial);

    // setFileName_SinglePass([...singlePass]);
    // setFileName_MultiPass([...MultiPass]);
    // setFileName_IntROEDI([...EDIFlowsheet]);
    // setFileName_Argo([...argoAnalyzer]);
    // setFileName_Tutorial([...tutorial]);

    // Abhihsek 14-4 end

    // setFileName_SinglePass(['Acid-H2S_Stripper-Caustic-RO', 'Acid-SWRO', 'RO-Amm Stripper']);
    // setFileName_MultiPass(['RO1-Acid-RO2', 'Acid-RO1-Degasser-RO2']);
    // setFileName_IntROEDI(['NaX-RO-Degasser-EDI']);
    // // setFileName_Argo(['Argo_template', 'Argo_template_Feed_dosing', 'Argo_template_Product_dosing']);
    // setFileName_Argo(['Argo_template', 'Argo_template_Feed_dosing', 'Argo_template_Product_dosing', 'Argo_template_SWRO_2pass', 'Argo_template_SWRO_1pass']);
    // setFileName_Tutorial(['3pRO_ConcRecycleToP2_EDI(SWfeed)', 'Acid_H2SStripper_Caustic_1pRO',
    //   'Acid_2pRO_Degasser', '3pRO_ConcRecycleToP2(SWfeed)', '1pRO (Brackishwater feed)', '1pRO (Seawater feed)',
    //   '2pNF_RO (Seawater feed)', '2pRO (Seawater feed)', '2pRO-EDI (Brackishwater feed)', '1pRO-EDI (Brackishwater feed)',
    //   '1pNF (Seawater feed)', 'Standalone EDI', '1pass RO with recycle', 'Permeate recirculation last stage', '1pass RO with Pelton', '1pass RO with PX', '1pass RO with Turbo', '1pass RO with WX', '2pass Partial with PX', '2Pass Partial', '2pass RO with PX Recycle', '2pass RO with PX',
    //   '2pass Split with PX', '2Pass Split', 'High Pass2 Recovery']);

    // if (firstFlag) {
    //   setFirstFlag(false);
    //   selectedFile('Single-Pass Design', 0);
    //   // setLoadedFile(['Acid-H2S_Stripper-Caustic-RO', 'Acid-SWRO', 'RO-Amm Stripper']);
    //   setLoadedFile([...singlePass]);
    //   getUserListData();
    // }
    setTimeout(() => {
      removeItemFromLocalStorage();
      removeLocalStorageValue();
    }, 0);

  }, []);
  const [, setIsHovering] = useState(false);
  const [, setIsHoverId] = useState(0);

  const handleMouseEnter = (j) => {
    setIsHovering(true);
    setIsHoverId(j);
    const updatedIcons = [...icons];
    if (j === 0) {
      updatedIcons[j] = {
        defaultImage: singlePass_hover,
        hoverImage: singlePass_hover,
      };
    };
    if (j === 1) {
      updatedIcons[j] = {
        defaultImage: multiPass_hover,
        hoverImage: multiPass_hover,
      };
    };
    if (j === 2) {
      updatedIcons[j] = {
        defaultImage: roEdi_hover,
        hoverImage: roEdi_hover,
      };
    };
    if (j === 3) {
      updatedIcons[j] = {
        defaultImage: TemplateArgo_hover,
        hoverImage: TemplateArgo_hover,
      };
    };
    if (j === 4) {
      updatedIcons[j] = {
        defaultImage: tutorial_hover,
        hoverImage: tutorial_hover,
      };
    };

    setIcons(updatedIcons);
  };

  const handleMouseLeave = (j) => {
    setIsHovering(false);

    const updatedIcons = [...icons];

    if (j === 0) {
      updatedIcons[j] = {
        defaultImage: singlePass_icon,
        hoverImage: singlePass_hover,
      };
    };
    if (j === 1) {
      updatedIcons[j] = {
        defaultImage: multiPass_icon,
        hoverImage: multiPass_hover,
      };
    };
    if (j === 2) {
      updatedIcons[j] = {
        defaultImage: roEdi_icon,
        hoverImage: roEdi_hover,
      };
    };
    if (j === 3) {
      updatedIcons[j] = {
        defaultImage: TemplateArgo,
        hoverImage: TemplateArgo_hover,
      };
    };
    if (j === 4) {
      updatedIcons[j] = {
        defaultImage: tutorial_icon,
        hoverImage: tutorial_hover,
      };
    };

    setIcons(updatedIcons);
  };

  const { innerHeight } = window;
  return (
    <div style={{ height: innerHeight, backgroundColor: '#FCFCFC' }}>
      <div>

        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={fetchLoading}
        // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <HeaderSection />
        <div className='preconfig-wrapper' >
          <Grid container className='preconfig_container'>
            <Grid item xs={12} className='Main_Heading L_heading'>{translateObject('Pre-Configured Design')}</Grid>
            <Tabs
              onChange={handleChangetab}
              value={value}>
              {(data || []).map((obj, i) => (
                <Tab key={i}
                  id={obj.id}
                  style={{ display: i === 5 ? 'none' : 'flex' }}
                  icon={<img src={(currentPreConfigActive) === i ? icons[i].hoverImage : icons[i].defaultImage} />} iconPosition="start"
                  className={`active ${currentPreConfigActive === i ? 'currentActive' : ''}`}
                  onClick={() => selectedFile(obj.label, i)}
                  onMouseOver={() => handleMouseEnter(i)} onMouseOut={() => handleMouseLeave(i)}
                  label={translateObject(obj.label)} value={i} />
              ))}
            </Tabs>
          </Grid>
        </div>
        {/* Card View code */}
        <Grid container className='preconfig_output_container'>
          <Grid item xs={12}>
            <div className='wrapper-sort'>
              {(loadedFile || []).map((obj, i) => (
                <div className="RomCard" key={i}>
                  <div className='cardHeader'> {obj.split('/')[1]}
                    <span style={{ display: obj.length >= 22 ? 'none' : 'block' }}>&nbsp;</span>
                  </div>
                  <div className='pfr'>&nbsp;</div>
                  <Button
                    id={`${fileType}_${i}`}
                    variant="contained"
                    data-testid={`fileType${i}`}
                    className='Secondary-Default_button'
                    onClick={() => navigate(`/main?preconfig/${obj}.json`)}
                    // onClick={() => navigate('/main?preconfig/Single Pass/Brine Staged RO.json')}
                    endIcon={<img src={ROMOpen} alt="ROMOpen" />}>
                    {translateObject('Open')}
                  </Button>
                </div>
              ))}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default PreConfigV;
